export class hardwareOrder {
  constructor({
    hardwareOrderID = 0,
    orderID = 0,
    addressID = 0,
    contactID = 0,
    contactName = null,
    contactMobile = null,
    contactEmail = null,
    deliveryInstructions = null,
    hardwareOrderDetails = null,
    subTotal = 0.0,
    freight = 0.0,
    totalInitialPayment = 0.0,
  } = {}) {
    this.hardwareOrderID = hardwareOrderID;
    this.orderID = orderID;
    this.contactName = contactName;
    this.contactMobile = contactMobile;
    this.contactEmail = contactEmail;
    this.addressID = addressID;
    this.hardwareOrderDetails = hardwareOrderDetails;
    this.subTotal = subTotal;
    this.freight = freight;
    this.totalInitialPayment = totalInitialPayment;
    this.contactID = contactID;
    this.deliveryInstructions = deliveryInstructions;
  }
}

export function CreateHardwareOrder(data) {
  return Object.freeze(new hardwareOrder(data));
}
